import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "@phosphor-icons/react";

// Testimonials strip — used on Home
export default function TestimonialsStrip() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials", { params: { limit: 6 } }).then((r) => setItems(r.data.items)); }, []);
  if (!items.length) return null;
  return (
    <section className="py-24 lg:py-32 border-t border-neutral-100 bg-[#ffffff]" data-testid="testimonials-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-4">
            <div className="overline text-[#001588] mb-4">Client voices</div>
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight">
              What our clients<br/>
              <span className="italic text-neutral-600">actually say.</span>
            </h2>
          </div>
          <div className="md:col-span-8 grid md:grid-cols-2 gap-6">
            {items.slice(0, 4).map((t) => (
              <figure key={t.id} className="border border-neutral-200 p-6" data-testid={`testimonial-${t.id}`}>
                <div className="flex items-center gap-1 mb-3 text-[#001588]">
                  {[...Array(t.rating || 5)].map((_, i) => <Star key={i} size={12} weight="fill" />)}
                </div>
                <blockquote className="font-serif text-lg leading-relaxed text-neutral-800 italic">"{t.quote}"</blockquote>
                <figcaption className="flex items-center gap-3 mt-5 pt-4 border-t border-neutral-200">
                  {t.author_photo && <img src={t.author_photo} alt={t.author_name} className="w-10 h-10 rounded-full object-cover" loading="lazy" />}
                  <div>
                    <div className="text-sm text-neutral-900 font-medium">{t.author_name}</div>
                    <div className="text-[10px] uppercase tracking-wider text-neutral-500">{t.author_role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
